<template>
  <button
      :disabled="loading"
      :title="title"
      class="logout-button btn btn-text btn-sm btn-icon"
      @click="handleLogout"
  >
    <span v-if="loading" class="loading-spinner"></span>
    <span v-if="!loading" style="font-size: 24px">⏻</span>
  </button>
</template>

<script setup>
import {computed} from 'vue'
import {useRoute, useRouter} from 'vue-router'
import {usePlanningStore} from '@/store/planningStore'
import {storeToRefs} from 'pinia'
import RouteEnum from "@/router/RouteEnum";

const props = defineProps({
  userAccountObjId: {
    type: Number,
  }
})

const router = useRouter()
const route = useRoute()
const planningStore = usePlanningStore()
const {loading} = storeToRefs(planningStore)

const title = computed(() => {
  return loading.value ? 'Déconnexion en cours...' : 'Se déconnecter'
})

const handleLogout = async () => {
  planningStore.logout()
  await router.push({name: RouteEnum.PLANNING_LOGIN, query: {returnTo: route.fullPath}})
}
</script>

<style scoped>
.logout-button {
  position: relative;
  overflow: hidden;
}

.logout-button.btn-text {
  background: transparent;
  border: none;
  color: var(--secondary);
  padding: 8px 12px;
  transition: color 0.2s ease;
}

.logout-button.btn-text:hover {
  color: var(--primary);
  background: rgba(var(--primary), 0.05);
}

.logout-button.btn-icon {
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  border-radius: 50%;
}

.logout-button.btn-sm.btn-icon {
  width: 32px;
  height: 32px;
}

.loading-spinner {
  display: inline-block;
  width: 16px;
  height: 16px;
  border: 2px solid transparent;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin-right: 8px;
}

.logout-button.btn-icon .loading-spinner {
  margin-right: 0;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
